<template>
  <div class="breakdown-card">
    <div class="w-full p-4 flex items-center justify-between">
      <BaseText type="label" size="sm" class="text-text-normal">
        Video Analysis
      </BaseText>
      <BaseText type="label" size="sm" class="text-text-muted">
        Audience Retention
      </BaseText>
    </div>
    <!-- Line Graph -->
    <div class="relative w-full pl-4 pr-6 pt-1 pb-4">
      <transition>
        <div v-if="loading" class="absolute w-full h-full flex items-center justify-center z-50">
          <BaseLoadingSpinnerCircle class="mb-10 text-icon-normal" :width="24" :height="24" :duration="1" />
        </div>
      </transition>
      <RetentionLineGraph 
        ref="retentionLineGraph" 
        class="transition-opacity" :class="{ 'opacity-50': loading }"
        :advertisement="advertisement"
        :retention-series="retentionSeries"
        @updatePlayerTime="handlePlayerTimeUpdate"
      />
    </div>
  </div>
</template>

<script>
import RetentionLineGraph from './video/RetentionLineGraph.vue'

export default {
  name: 'VideoAnalysisBreakdown',
  components: {
    RetentionLineGraph
  },
  props: {
    advertisement: {
      type: Object,
      required: true
    },
    retentionSeries: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      videoPlayer: null,
      customPlayEvent: null
    }
  },
  created () {
    this.customPlayEvent = new CustomEvent('playedexternally')
  },
  mounted () {
    this.$nextTick(() => {
      this.videoPlayer = document.querySelector('.drawer-video')
      this.videoPlayer.addEventListener('timeupdate', this.handleProgressBarUpdate)
    })
  },
  beforeDestroy () {
    this.videoPlayer.removeEventListener('timeupdate', this.handleProgressBarUpdate)
  },
  methods: {
    handleProgressBarUpdate (event) {
      // Update the progress bar
      const player = event.target
      if (this.$refs.retentionLineGraph) {
        this.$refs.retentionLineGraph.updateProgress(player.currentTime)
      }
    },
    handlePlayerTimeUpdate (time) {
      // Update the video player's time
      const player = this.videoPlayer
      if (!player.paused) {
        player.dispatchEvent(this.customPlayEvent)
      }
      player.currentTime = time
    }
  }
}
</script>

<style scoped>
.v-enter-active, .v-leave-active {
  transition: opacity 150ms ease-in-out;
}
.v-enter-from, .v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave-from {
  opacity: 1;
}
</style>